import base from "../base";
import resortBase from "../base/resort";
import logo from "./logo.svg";
import backgroundImage from "./background.jpg";
import favicon16 from "./favicon-16x16.png";
import favicon32 from "./favicon-32x32.png";
import favicon96 from "./favicon-96x96.png";
import { BrandInterface } from "../interface";

const schweitzer = {
  ...base,
  ...resortBase,
  title: "Schweitzer",
  logo,
  backgroundImage,
  resortURL: "https://www.schweitzer.com",
  favicons: {
    "16x16": favicon16,
    "32x32": favicon32,
    "96x96": favicon96,
  },
  color: {
    ...base.color,
    ...resortBase.color,
    header: "#191919",
    footer: "#191919",
    footerText: "#FFFFFF",
    button: "#0ED772",
    buttonHover: "#3EDF8E",
    buttonText: "#191919",
    link: "#E55932",
    linkHover: "#CC4F2D",
  },
} as BrandInterface;

export default schweitzer;
